import React from 'react';
import PolicyLayout from './PolicyLayout';

const ReturnRefundPage: React.FC = () => (
  <PolicyLayout title="Return & Refund Policy" lastUpdated="August 1, 2026">
    <section>
      <h2>1. Return Window</h2>
      <p>We accept returns within <strong>7 days</strong> of delivery. Items must be in their original condition with all tags attached.</p>
    </section>

    <section>
      <h2>2. Eligible Return Conditions</h2>
      <ul>
        <li>Item received is damaged or defective</li>
        <li>Wrong size or colour delivered</li>
        <li>Item significantly different from product description</li>
        <li>Item is incomplete or missing accessories</li>
      </ul>
    </section>

    <section>
      <h2>3. Non-Returnable Items</h2>
      <ul>
        <li>Items that have been worn, washed, or altered</li>
        <li>Items without original packaging or tags</li>
        <li>Innerwear and swimwear (for hygiene reasons)</li>
        <li>Items purchased on clearance or final sale</li>
        <li>Customised or personalised products</li>
      </ul>
    </section>

    <section>
      <h2>4. Return Process</h2>
      <ol>
        <li>Email <strong><a href="mailto:sastadealpvt@gmail.com">sastadealpvt@gmail.com</a></strong> with your order number and reason for return</li>
        <li>Attach clear photos of the item showing the issue</li>
        <li>Our team will review and respond within 2 business days</li>
        <li>If approved, you will receive return shipping instructions</li>
        <li>Pack the item securely and ship it to our address</li>
      </ol>
    </section>

    <section>
      <h2>5. Refund After Return</h2>
      <p>Once we receive and inspect the returned item:</p>
      <ul>
        <li><strong>Approved:</strong> Refund processed within 5–7 business days to original payment method</li>
        <li><strong>Wallet Refund:</strong> Credited within 24 hours if paid via wallet</li>
        <li><strong>Rejected:</strong> Item returned to you at your cost</li>
      </ul>
    </section>

    <section>
      <h2>6. Exchange Policy</h2>
      <p>We currently offer exchanges for size-related issues. Contact us within 7 days of delivery to request an exchange. Exchanges are subject to stock availability.</p>
    </section>

    <section>
      <h2>7. Return Shipping</h2>
      <ul>
        <li><strong>Our fault (wrong/defective item):</strong> We cover return shipping</li>
        <li><strong>Customer preference:</strong> Customer bears return shipping cost</li>
      </ul>
    </section>

    <section>
      <h2>8. Contact</h2>
      <p>
        <strong>SASTA DEAL PRIVATE LIMITED</strong><br />
        Floor No. Gr - Fr, Building No. 114/K,<br />
        Raja S.C. Mullick Road, Near Naktala, Garia,<br />
        Kolkata, West Bengal – 700047<br />
        Email: <strong><a href="mailto:sastadealpvt@gmail.com">sastadealpvt@gmail.com</a></strong>
      </p>
    </section>
  </PolicyLayout>
);

export default ReturnRefundPage;
